export const validatePasswordRules = (password = "", context = {}) => {
  const value = typeof password === "string" ? password : "";
  const normalizedPassword = value.trim().toLowerCase();
  const normalizedEmail = String(context.email || "").trim().toLowerCase();
  const normalizedUserName = String(context.userName || "").trim().toLowerCase();
  const normalizedFullName = String(context.fullName || "").trim().toLowerCase();

  return {
    minLength: value.length >= 10,
    maxLength: value.length <= 64,
    hasUpper: /[A-Z]/.test(value),
    hasLower: /[a-z]/.test(value),
    hasNumber: /[0-9]/.test(value),
    hasSymbol: /[^A-Za-z0-9]/.test(value),
    noOuterSpaces: value === value.trim(),
    notOnlySpaces: value.trim().length > 0,
    notEmail: !normalizedPassword || normalizedPassword !== normalizedEmail,
    notUserName: !normalizedPassword || normalizedPassword !== normalizedUserName,
    notFullName: !normalizedPassword || normalizedPassword !== normalizedFullName,
  };
};

export const getPasswordRuleItems = (password = "", context = {}) => {
  const rules = validatePasswordRules(password, context);
  return [
    { key: "minLength", label: "10 caracteres", passed: rules.minLength },
    { key: "hasUpper", label: "Mayúscula", passed: rules.hasUpper },
    { key: "hasLower", label: "Minúscula", passed: rules.hasLower },
    { key: "hasNumber", label: "Número", passed: rules.hasNumber },
    { key: "hasSymbol", label: "Símbolo", passed: rules.hasSymbol },
  ];
};

export const passwordPolicyMessages = (password = "", context = {}) => {
  const rules = validatePasswordRules(password, context);
  const messages = [];
  if (!rules.minLength) messages.push("La contraseña debe tener al menos 10 caracteres.");
  if (!rules.maxLength) messages.push("La contraseña no debe tener más de 64 caracteres.");
  if (!rules.noOuterSpaces) messages.push("La contraseña no debe iniciar ni terminar con espacios.");
  if (!rules.notOnlySpaces) messages.push("La contraseña no puede contener solo espacios.");
  if (!rules.hasUpper) messages.push("Debe contener una mayúscula.");
  if (!rules.hasLower) messages.push("Debe contener una minúscula.");
  if (!rules.hasNumber) messages.push("Debe contener un número.");
  if (!rules.hasSymbol) messages.push("Debe contener un símbolo.");
  if (!rules.notEmail) messages.push("La contraseña no puede ser igual al email.");
  if (!rules.notUserName) messages.push("La contraseña no puede ser igual al usuario.");
  if (!rules.notFullName) messages.push("La contraseña no puede ser igual al nombre.");
  return messages;
};

export const isPasswordPolicyValid = (password = "", context = {}) =>
  passwordPolicyMessages(password, context).length === 0;
